import { render, staticRenderFns } from "./promo-countdown.vue?vue&type=template&id=9b39c2d2&scoped=true&"
import script from "./promo-countdown.vue?vue&type=script&lang=js&"
export * from "./promo-countdown.vue?vue&type=script&lang=js&"
import style0 from "./promo-countdown.vue?vue&type=style&index=0&id=9b39c2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b39c2d2",
  null
  
)

export default component.exports